import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { BillingHeaderComponent } from '../../billing-header/billing-header.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreLoadingComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Params , RouterModule } from '@angular/router';
import { FormBaseControlService } from '@mapfre-design-library/src/public_api';
import { PolicyDataService } from '@services/data-services/policy-data.service';
import { SelfRequestFormService } from '@services/forms/self-request-form/self-request-form.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbFormsModule, MapfreLoadingComponent, MapfreCardComponent, BillingHeaderComponent, MapfreButtonComponent],
  selector: 'app-initiate-refund',
  templateUrl: './initiate-refund.component.html',
  styleUrls: ['./initiate-refund.component.scss']
})
export class InitiateRefundComponent implements OnInit {

  refundFormGroup: FormGroup;
  requestType: string;
  inputs: any[];
  policy: any;
  policyType: string;
  policyTypeImg: string;
  loading: boolean;

  constructor(
    private selfRequestForm: SelfRequestFormService,
    private formBaseControl: FormBaseControlService,
    private activatedRoute: ActivatedRoute,
    private policyDataService: PolicyDataService,
    private location: Location
  ) {
    this.requestType = "initiate";
    this.inputs = this.selfRequestForm.getInputs(this.requestType);
   }
  sendRequest(){
    //do ntohing
  }
  ngOnInit(): void {
    this.refundFormGroup = this.formBaseControl.toFormGroup(this.inputs);
    this.activatedRoute.params.subscribe((params: Params) => {
      const policyId = params['policyid'];
      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        if (policyResponse) {
          this.policy = policyResponse
                          .find(policyDetails => policyDetails.policynumber.policyNumber === policyId);
          this.setPolicyTypeData(this.policy.policyType)
          this.loading = false;
        }       
      });
    });
  }

  setPolicyTypeData(policyType){
    if(policyType.includes('AUTO')){
      this.policyTypeImg = "./assets/img/images/icon-car.svg";
    } else if (policyType.includes('HOME')){
      this.policyTypeImg = "./assets/img/images/icon-home.svg";
    }else{
      this.policyTypeImg = "./assets/img/images/icon-umbrella.svg";
    }
  }

  onClickBack(){
    this.location.back();
  }

}
